import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pagination" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_pagination, {
      "hide-on-single-page": true,
      "current-page": _ctx.selectedPage,
      "page-count": _ctx.totalPages,
      onCurrentChange: _ctx.changeCurrentPage,
      layout: _ctx.pagerLayout,
      size: "large"
    }, null, 8, ["current-page", "page-count", "onCurrentChange", "layout"])
  ]))
}